import React, { Component, createRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

class DescDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: '',
            isOpened: false
        }
    }

    handleSelectDescDropdown = async data => {
        this.setState({
            selected: data,
            isOpened: false
        })
        await this.props.handleChange(data);
        if (this.props.handleReset !== undefined) {
            this.props.handleReset();
        }
    }

    handleDescDropdown = e => {
        if (this.dropdownRef && !this.dropdownRef.current.contains(e.target)) {
            this.setState({
                isOpened: false
            })
        }
    }

    selectedValueDescDropdown = () => {
        if (this.props.reset) {
            return this.props.placeholder
        }
        return this.state.selected !== '' ? this.state.selected.label : this.props.placeholder
    }

    componentDidMount() {
        this.dropdownRef = createRef()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.isOpened !== this.state.isOpened) {
            if (this.state.isOpened) {
                document.addEventListener('click', this.handleDescDropdown)
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleDescDropdown)
    }

    render() {
        return (
            <div className={this.state.isOpened ? "dropdown opened" : "dropdown"}>
                <div className="dropdown-select" id="btndropdown" onClick={() => this.setState({ isOpened: !this.state.isOpened })} ref={this.dropdownRef}>
                    <span className={this.state.selected !== '' && !this.props.reset ? "select truncate" : "select text-gray-500"}>
                        {this.selectedValueDescDropdown()}
                    </span>
                    <FontAwesomeIcon icon={faChevronDown} className="select-icon" />
                </div>
                <div className={this.state.isOpened ? "dropdown-list" : "hidden"}>
                    {
                        this.props.data.map((data, idx) =>
                            <div className="dropdown-list__item" key={idx} id="btndropdownselect" onClick={() => this.handleSelectDescDropdown(data)}>
                                {
                                    this.state.selected.value === data.value && !this.props.reset ?
                                        <div className="pt-2 pl-2 pr-2 bg-blue-200 text-darkblue">
                                            <div className={this.props.data.length === idx + 1 ? "pb-2" : "pb-2 border-b-2 border-gray"}>
                                                <div className="flex justify-between items-center">
                                                    <div className="truncate text-sm">{data.label}</div>
                                                    <div className="flex items-center">
                                                        <div className={data.isOnline ? "bg-lightgreen rounded-full h-3 w-3 mr-0.5" : "bg-lightred rounded-full h-3 w-3 mr-0.5"} ></div>
                                                        <p className="text-xs italic">{data.isOnline ? "Online" : "Offline"}</p>
                                                    </div>
                                                </div>
                                                {
                                                    data.description.map((data, idx) =>
                                                        <div className="truncate text-xs inline-block" key={idx}>
                                                            <div className="mr-1">{data.complaint_description}</div>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                        :
                                        <div className="pt-2 pl-2 pr-2 hover:bg-blue-100">
                                            <div className={this.props.data.length === idx + 1 ? "pb-2" : "pb-2 border-b-2 border-gray"}>
                                                <div className="flex justify-between items-center">
                                                    <div className="truncate text-sm">{data.label}</div>
                                                    <div className="flex items-center">
                                                        <div className={data.isOnline ? "bg-lightgreen rounded-full h-3 w-3 mr-0.5" : "bg-lightred rounded-full h-3 w-3 mr-0.5"} ></div>
                                                        <p className="text-xs italic">{data.isOnline ? "Online" : "Offline"}</p>
                                                    </div>
                                                </div>
                                                {
                                                    data.description.map((data, idx) =>
                                                        <div className="truncate text-xs inline-block" key={idx}>
                                                            <div className="mr-1">{data.complaint_description}</div>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                }
                            </div>
                        )
                    }
                </div>
            </div>
        );
    }
}

export default DescDropdown;